import { render, staticRenderFns } from "./SliderCategories.vue?vue&type=template&id=6fe284f1"
import script from "./SliderCategories.vue?vue&type=script&lang=js"
export * from "./SliderCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports